import i18n from 'i18next'
import en from './en.json'
import de from './de.json'
import ar from './ar.json'

i18n
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: 'en',
    debug: false,
    locales: ['en', 'de', 'ar'],
    resources: { en: { translation: en }, de: { translation: de }, ar: { translation: ar } },
    returnObjects: true,
    interpolation: {
      skipOnVariables: false
    }
  })

export default i18n
